import { IonAccordion, IonAccordionGroup, IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonContent, IonDatetime, IonGrid, IonHeader, IonInfiniteScroll, IonInfiniteScrollContent, IonInput, IonItem, IonItemDivider, IonLabel, IonModal, IonRow, IonSelect, IonSelectOption, IonTitle, IonToolbar } from '@ionic/react';
import CustomDate from '../common/CustomDate';
import './../ExploreContainer.css';
import API from '../../utils/API';
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import SearchUser from '../common/SearchUser';
import SelectProject from '../common/SelectProject';
import SelectBuyer from '../common/SelectBuyer';
import SelectSupplier from '../common/SelectSupplier';
import SelectCostCenter from '../common/SelectCostCenter';
import { useHistory, useParams } from 'react-router';
import PersonalProfile from './PersonalProfile';
import JobPositionDetails from './JobPositionDetails';
import EmployeeAddress from './EmployeeAddress';
import EmergencyContact from './EmergencyContact';
import EducationDetails from './EducationDetails';
import ExperienceDetails from './ExperienceDetails';
interface ContainerProps {
    name: string;
}

const CreateEmployee: React.FC<ContainerProps> = ({ name }) => {
    const params: any = useParams();
    const empID = params?.empID;
    const [employee, setEmployee] = useState<any>({
        // startDate: '',
        // firstName: '',
        // lastName: '',
        // email: '',
        // phone: '',
        // addressFirstLine: '',
        // city: '',
        // state: '',
        // zip: '',
        // country: '',

        // salary: '',
        // perHourBillingRate: ''

        // employmentType: '',
        // departmentType: '',

        // managerID: '',
        // managerName: '',

        // projectId: '',
        // projectName: '',

        // buyerId: '',
        // buyerName: '',

        // supplierId: '',
        // supplierName: '',

        // costCenterId: '',
        // costCenterName: '',

        // emergencyContactFirstName: '',
        // emergencyContactLastName: '',
        // emergencyContactEmail: '',
        // emergencyContactPhone: '',
        // emergencyContactAddressFirstLine: '',
        // emergencyContactAddressSecondLine: '',
        // emergencyContactCity: '',
        // emergencyContactState: '',
        // emergencyContactZIP: '',
        // emergencyContactCountry: '',
    });

    const getDate = (date: string) => { // the callback. Use a better name
        console.log(date);
        setEmployee((values: any) => ({
            ...values,
            'startDate': date,
        }));
    };

    const getEmployee = (manager: any) => { // the callback. Use a better name
        setEmployee((values: any) => ({
            ...values,
            'managerId': manager?._id,
            'managerName': manager?.firstName + ', ' + manager?.lastName
        }));
    };

    const getProject = (project: any) => { // the callback. Use a better name
        setEmployee((values: any) => ({
            ...values,
            'projectId': project?._id,
            'projectName': project?.name
        }));
    };

    const getBuyer = (buyer: any) => { // the callback. Use a better name
        console.log(buyer);
        setEmployee((values: any) => ({
            ...values,
            'buyerId': buyer?._id,
            'buyerName': buyer?.name,

        }));
    };

    const getSupplier = (supplier: any) => { // the callback. Use a better name
        setEmployee((values: any) => ({
            ...values,
            'supplierId': supplier?._id,
            'supplierName': supplier?.name
        }));
    };

    const getCostCenter = (costCenter: any) => { // the callback. Use a better name
        setEmployee((values: any) => ({
            ...values,
            'costCenterId': costCenter?._id,
            'costCenterName': costCenter?.name,
        }));
    };

    const handleInputChange = (event: any) => {
        setEmployee((values: any) => ({
            ...values,
            [event.target.name]: event.target.value,
        }));
    };

    // const createNewOrganization = () => {
    //     console.log(employee);
    //     API().post('/employee/saveEmployee', { "req": employee }).then((data: any) => {
    //         setEmployee((values:any) => ({
    //             ...values,
    //             id: data._id
    //         }));
    //     }, e => {
    //         console.log(e);
    //     });
    // }

    // const addEmployeeAddress = () => {
    //     console.log(employee);
    //     API().post('/employee/saveEmployee', { "req": employee }).then((data) => {

    //     }, e => {
    //         console.log(e);
    //     });
    // }
    const addEmployeePOC = () => {
        console.log(employee);
        API().post('/employee/saveEmployee', { "req": employee }).then((data: any) => {
            setEmployee((values: any) => ({
                ...values,
                id: data.data._id
            }));
        }, e => {
            console.log(e);
        });
    }

    useEffect(() => {
        (async () => {
            if (empID) {
                const { data, status, statusText, headers, request, config } = await API().post('/employee/getEmployeeByID', { "req": employee });
                console.log(data);
                console.log(data + "1" + status + "1" + statusText + "1" + headers + "1" + request + "1" + config);
                await setEmployee((values: any) => ({
                    ...values,
                    ...data
                }));
            }
        })();
    }, [empID])

    return (
        <IonContent>
            {/* <IonInfiniteScroll>
                <IonInfiniteScrollContent> */}
            <IonGrid>
                <IonAccordionGroup className='m-4'>
                    <IonAccordion className='mb-2' value="None">
                        <IonItem color={'primary'} slot="header">
                            <IonLabel>Personal Profile</IonLabel>
                        </IonItem>
                        <div className="ion-padding" slot="content">
                            <PersonalProfile></PersonalProfile>
                        </div>
                    </IonAccordion>
                    <IonAccordion className='mb-2' value="zero">
                        <IonItem color={'primary'} slot="header">
                            <IonLabel>Job Position Details</IonLabel>
                        </IonItem>
                        <div className="ion-padding" slot="content">
                            <JobPositionDetails></JobPositionDetails>
                        </div>
                    </IonAccordion>
                    <IonAccordion className='mb-2' value="first">
                        <IonItem color={'primary'} slot="header">
                            <IonLabel>Employee Address</IonLabel>
                        </IonItem>
                        <div className="ion-padding" slot="content">
                            <EmployeeAddress></EmployeeAddress>
                        </div>
                    </IonAccordion>
                    <IonAccordion className='mb-2' value="second">
                        <IonItem color={'primary'} slot="header">
                            <IonLabel>Emergency Contact Details</IonLabel>
                        </IonItem>
                        <div className="ion-padding" slot="content">
                            <EmergencyContact></EmergencyContact>
                        </div>
                    </IonAccordion>
                    <IonAccordion className='mb-2' value="third">
                        <IonItem color={'primary'} slot="header">
                            <IonLabel>Education Details</IonLabel>
                        </IonItem>
                        <div className="ion-padding" slot="content">
                            <EducationDetails></EducationDetails>
                        </div>
                    </IonAccordion>
                    <IonAccordion className='mb-2' value="fourth">
                        <IonItem color={'primary'} slot="header">
                            <IonLabel>Experience Details</IonLabel>
                        </IonItem>
                        <div className="ion-padding" slot="content">
                            <ExperienceDetails></ExperienceDetails>
                        </div>
                    </IonAccordion>
                    <IonAccordion className='mb-2' value="fifth">
                        <IonItem color={'primary'} slot="header">
                            <IonLabel>Insurance Information</IonLabel>
                        </IonItem>
                        <div className="ion-padding" slot="content">
                            Third Content
                        </div>
                    </IonAccordion>
                    <IonAccordion className='mb-2' value="sixth">
                        <IonItem color={'primary'} slot="header">
                            <IonLabel>Performance Rating</IonLabel>
                        </IonItem>
                        <div className="ion-padding" slot="content">
                            Third Content
                        </div>
                    </IonAccordion>
                    <IonAccordion className='mb-2' value="seventh">
                        <IonItem color={'primary'} slot="header">
                            <IonLabel>Social Networking</IonLabel>
                        </IonItem>
                        <div className="ion-padding" slot="content">
                            Third Content
                        </div>
                    </IonAccordion>
                </IonAccordionGroup>

                {/* <IonRow className="d-flex justify-content-center mt-4">
                    <IonCol size="12" size-sm >
                        <IonButton shape="round" fill="outline" onClick={createNewOrganization}>Create Employee</IonButton>
                    </IonCol>
                </IonRow> */}

                {/* <IonRow className="d-flex justify-content-center mt-4">
                    <IonCol size="12" size-sm >
                        <IonButton shape="round" fill="outline" onClick={addEmployeeAddress}>Add Employee Address</IonButton>
                    </IonCol>
                </IonRow> */}

                {/* <IonRow className="d-flex justify-content-center mt-4">
                    <IonCol size="12" size-sm >
                        <IonButton shape="round" fill="outline" onClick={addEmployeePOC}>Create Employee</IonButton>
                    </IonCol>
                </IonRow> */}
            </IonGrid>
            {/* </IonInfiniteScrollContent>
            </IonInfiniteScroll> */}
        </IonContent >
    );
};

export default CreateEmployee;
